import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { applyNoIndex } from "@/lib/seo";

/**
 * Redirect canônico que marca a rota como noindex e aponta o canonical
 * para o destino antes de navegar. Usado em /index e /home → /.
 */
export const CanonicalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    applyNoIndex({ canonicalPath: to });
  }, [to]);
  return <Navigate to={to} replace />;
};
